export const transformBrowserNameToBrowserType = (browser: string): string | null => {
  if (!browser) {
    return null;
  }
  const browserLowerCase = browser.toLowerCase();
  if (browserLowerCase.indexOf('ie') > -1) {
    return 'IE';
  }
  if (browserLowerCase.indexOf('chrome') > -1) {
    return 'Chrome';
  }
  if (browserLowerCase.indexOf('chromium') > -1) {
    return 'Chromium';
  }
  if (browserLowerCase.indexOf('firefox') > -1) {
    return 'Firefox';
  }
  if (browserLowerCase.indexOf('edge') > -1) {
    return 'Edge';
  }
  if (browserLowerCase.indexOf('opera') > -1) {
    return 'Opera';
  }
  if (browserLowerCase.indexOf('safari') > -1) {
    return 'Safari';
  }
  return null;
};
